import { LinksSchemaType } from "../type";

export const villaLinksArray: LinksSchemaType = {
  main: "/villa",
  maintitle: "صفحه اصلی ویلا و اقامتگاه ",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/villa-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/villa-mobile.png`,
  otherlinks: [
    {
      title: "رزرو ویلا تهران",
      href: "/villa/city/tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran.png`
    },
    {
      title: "رزرو ویلا کردان",
      href: "/villa/city/kordan",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/kordan.png`
    },
    {
      title: "رزرو ویلا رامسر",
      href: "/villa/city/ramsar",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/ramsar.png`
    },
    {
      title: "رزرو ویلا چالوس",
      href: "/villa/city/chalus",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/chalus.png`
    },
    {
      title: "رزرو اقامتگاه مشهد",
      href: "/villa/city/mashhad",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/mashhad.png`
    },
    {
      title: "رزرو ویلا بندر انزلی",
      href: "/villa/city/bandaranzali",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/bandar-anzali.png`
    },
    {
      title: "رزرو ویلا رشت",
      href: "/villa/city/rasht",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/rasht.png`
    }
  ]
};
